import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 0A408C8A-FD39-4160-9547-3A7895BCE942
 * name bench
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bench.svg
 * tags
 */
export const BenchIcon = createSvgIcon(<><path d="M23 13H1V15H3V19H5V15H19V19H21V15H23V13Z" /></>, 'BenchIcon');
export default BenchIcon